import React, { useState, useEffect } from 'react';
import { TextField } from "@material-ui/core"
import { NotificationsActive } from "@material-ui/icons"
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector} from 'react-redux'

import TimeoutButton from '../../Common/TimeoutButton';
import { editException, getExceptionDetails } from '../../../actions/editOrderActions';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { getUserPreference } from '../../../utilities/common';
import { operationLog } from '../../../actions/commonAction';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

export default function AbnormalRecords(props){
    const { orderInfo } = props;
    const {t} = useTranslation('editOrder'); 
    const dispatch = useDispatch();
    let userPref = getUserPreference();

    const [exceptionList, setExceptionList] = useState([]);
    const [exception, setException] = useState('');
    const [orderId, setOrderId] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [operationMemo, setOperationMemo] = useState('');

    useEffect(() => {
        setDisabled(true);
        setException('');
        if(orderInfo) {
            if(orderInfo.tracking) {
                setException(orderInfo.tracking.exception);
            }
            if(orderInfo.orders) {
                setOrderId(orderInfo.orders.order_id);
            }
            if(orderInfo.path) {
                const length = orderInfo.path.length;
                if(orderInfo.path[length - 1]) {
                    const statusCode = orderInfo.path[length - 1].code;
                    if(statusCode === 213 || 204) {
                        dispatch(getExceptionDetails())
                        .then((res) => {
                            res = [{id: 0, en_message: 'Clear Exception'}].concat(res);
                            setExceptionList(res)
                        })
                        setDisabled(false);
                    }
                }
            }
        }
    }, [orderInfo])

    return (
        <div style={{width: '100%'}}>
            <TextField
                fullWidth
                select
                label="Exceptions"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={exception}
                onChange={(e)=>{setException(e.target.value)}}
                style={{paddingBottom: 16}}
                disabled={disabled}
            >
                <option value="">
                    {t('select_exception')}
                </option>
                {exceptionList.map((exception) => (
                    <option key={exception.id} value={exception.id}>
                        {exception.en_message}
                    </option>
                ))}
            </TextField>
            <TextField 
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{paddingBottom: 16}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
            <TimeoutButton
                variant="contained"
                color='secondary'
                timeout={10000}
                fullWidth
                startIcon={<NotificationsActive />}
                onClick={handleExceptionSubmit}
                disabled={disabled}
            >
                {t('button_submit')}
            </TimeoutButton>
        </div>
    )

    function handleExceptionSubmit() {
        dispatch(editException(orderId, exception))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('exception_success_message'), type: 'success'}))
            dispatch(operationLog(orderId, userPref.username, 0, 2, 'OPERATION_EXCEPTION', operationMemo))
            setOperationMemo('');
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('exception_fail_message'), type: 'error'}))
        })
    }
}